import { Home, Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Logo from '@/icons/Logo';

interface PremiumAssessmentHeaderProps {
  assessmentTitle: string;
  customName?: string | null;
  userEmail: string;
  onGoHome: () => void;
  onEditName?: () => void;
}

export default function PremiumAssessmentHeader({
  assessmentTitle,
  customName,
  userEmail,
  onGoHome,
  onEditName,
}: PremiumAssessmentHeaderProps) {
  const displayName = customName?.trim() || assessmentTitle;
  return (
    <header className="border-b border-border/50 bg-card/80 backdrop-blur-sm sticky top-0 z-20">
      <div className="w-full px-4 md:px-6 py-3 flex items-center justify-between">
        {/* Left: Logo + name */}
        <div className="flex items-center gap-3 shrink-0 min-w-0">
          <Logo className="h-8 w-8" />
          <span className="font-semibold text-foreground truncate hidden sm:inline max-w-[40vw]">
            {displayName}
          </span>
          {onEditName && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onEditName}
              title="Rename assessment"
              className="h-7 w-7 shrink-0"
            >
              <Pencil className="h-3.5 w-3.5" />
            </Button>
          )}
        </div>

        {/* Right: Email + Home */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-muted-foreground hidden md:inline">{userEmail}</span>
          <Button variant="ghost" size="icon" onClick={onGoHome} title="Back to Home">
            <Home className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
